import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "disabled", "value"]
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ disabled: _ctx.disabled }, "input-container"])
  }, [
    _createElementVNode("input", {
      id: _ctx.id,
      class: _normalizeClass([{ disabled: _ctx.disabled }, "text-input"]),
      disabled: _ctx.disabled ?? false,
      value: _ctx.modelValue,
      required: "",
      type: "text",
      onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('blur', $event))),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, null, 42, _hoisted_1),
    _createElementVNode("label", {
      class: _normalizeClass([{ disabled: _ctx.disabled }, "label"]),
      for: _ctx.id
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.label), 1)
    ], 10, _hoisted_2)
  ], 2))
}